module.exports = __webpack_public_path__ + "static/media/flags_BOL.59b8329a.svg";